<template>
  <el-col :span="normalizedSpan" :style="style">
    <space :gutter="gutter" style="margin-bottom: var(--orion-form-validation-message-height)"> <slot></slot> </space>
  </el-col>
</template>

<script setup lang="ts">
import { ElCol } from 'element-plus'
import type { ButtonGroupProps } from './ButtonGroup'
import Space from '../../Space'
import { useFormItemSpan } from '../hooks'
import { computed, CSSProperties } from 'vue'

defineOptions({ name: 'OFormButtongroup', inheritAttrs: false })

const { gutter, align = 'right' } = defineProps<ButtonGroupProps>()
const style = computed<CSSProperties>(() => {
  return {
    textAlign: align,
  }
})

const normalizedSpan = useFormItemSpan()
</script>
